<template>
  <div class="card mb-3">
    <div class="card-body">
      <div class="card-title" v-if="!errors">
        <ul class="nav nav-pills" id="pills-tab" role="tablist">
          <li class="nav-item" role="presentation" v-for="(class_report, index) in classes">
            <button class="nav-link" :class="{ active: index == 0 }" :id="'pills-home-tab' + class_report.class_id" data-bs-toggle="pill" :data-bs-target="'#pills-' + class_report.class_id" type="button" role="tab"
              :aria-controls="'pills-' + class_report.class_id" aria-selected="true" @click="getMonthlyReport(class_report.class_id)">{{ class_report.class_name }}</button>
          </li>
        </ul>
      </div>
      <div class="card-content">
        <div class="d-flex flex-column align-items-center justify-content-center text-center" v-if="errors">
          <h5>{{ $t(errors) }} </h5>
          <img class="mt-3" src="/themes/ito/images/mascot/isaac-extension.svg" alt="" width="125px">
        </div>
        <div class="tab-content" id="pills-tabContent" v-else>
          <div class="tab-pane fade" :class="{ 'show active': index == 0 }" :id="'pills-' + class_report.class_id" role="tabpanel" aria-labelledby="pills-home-tab" v-for="(class_report, index) in classes">
            <div class="d-flex flex-column gap-3">
              <div class="d-flex flex-column">
                <h5 class="fs-5 text-bold">Academic reports</h5>
                <div class="row" v-if="!class_report.class_term.length">
                  <div class="d-flex flex-column align-items-center justify-content-center text-center">
                    <h5>{{ $t('parent_ar_mr_nodata') }} </h5>
                    <img class="mt-3" src="/themes/ito/images/mascot/isaac-extension.svg" alt="" width="125px">
                  </div>
                </div>
                <div class="row row-cols-3 g-3" v-else>
                  <div class="col" v-for="a_reporrt in class_report.class_term">
                    <div class="d-flex flex-column justify-content-center align-items-center gap-1" v-if="a_reporrt.isARVisible === true">
                      <img src="/themes/ito/images/parents/certificate.png" class="figure-img img-fluid rounded" alt="...">
                      <h5 class="fs-6 text-bold m-0">{{ class_report.class_name }}</h5>
                      <p class="m-0">{{ a_reporrt.term_name }}</p>
                      <button type="button" class="ito-btn ito-btn-secondary" @click="reviewAcademic(class_report.class_id, a_reporrt.term_id)">{{ $t('preview') }}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column" v-if="monthlyReport.length">
                <h5 class="fs-5 text-bold">Monthly Report</h5>
                <div class="row row-cols-3 g-3">
                  <div class="col" v-for="report in monthlyReport">
                    <div class="d-flex flex-column justify-content-center align-items-center gap-1">
                      <img src="/themes/ito/images/parents/certificate.png" class="figure-img img-fluid rounded" alt="...">
                      <h5 class="fs-6 text-bold m-0">{{ class_report.class_name }}</h5>
                      <p class="m-0">{{ report.format('MMMM, YYYY') }}</p>
                      <button type="button" class="ito-btn ito-btn-secondary" @click="reviewReport(class_report.class_id, report)">{{ $t('preview') }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from 'vuex'
import { getAcademicReport } from "../../models/parent";
import moment from 'moment';

export default {
  name: "AcademicReport",

  data() {
    return {
      classes: [],
      now: moment(),
      errors: undefined,
      startDate: moment('10-2024', 'MM-YYYY'),
      previousMonth: moment().subtract(1, 'month'),
      monthlyReport: []
    }
  },


  created() {
    this.fetch();
  },
  computed: {
    ...mapGetters([
      'user_info'
    ], () => {
      if (this.user_info) {
        return this.user_info
      }
      return this.user
    })
  },
  methods: {
    async fetch() {
      const that = this;
      const eco_user_id = that.user_info.eco_user_id;
      if (!eco_user_id) {
        that.errors = 'no_data';
        return;
      }
      that.$store.commit("setLoading", true);
      let formData = new FormData();
      formData.append('eco_user_id', eco_user_id);
      try {
        const { data } = await getAcademicReport(formData);
        that.classes = data.status === 200 ? data.data : [];
        if (that.classes && that.classes.every(item => item.class_id === null && item.class_name === null && item.class_term.length === 0)) {
          that.errors = 'no_data';
          return;
        }
        that.getMonthlyReport(that.classes[0].class_id)
      } catch (error) {
        console.error(error.message);
        that.errors = error.message || 'An error occurred';
      } finally {
        that.$store.commit("setLoading", false);
      }
    },

    async getMonthlyReport(class_id) {
      const that = this;
      that.$store.commit("setLoading", true);
      const params = {
        class_id: class_id
      }
      try {
        const data = await axios.get(`${process.env.VUE_APP_ECO_URL}/api_eco.php/getMonthlyByClassId`, { params })
        const reports = data.status === 200 ? data.data.data : [];
        const currentStudentReports = reports.filter(report => report.student_code === that.user_info.username);
        this.monthlyReport = currentStudentReports.flatMap(report =>
          report.month_Reports.map(monthReport => (
            moment(monthReport, "MM/YYYY")
          ))
        );
      } catch ({ response }) {
        console.error(response.data.results);
      } finally {
        that.$store.commit("setLoading", false);
      }
    },

    reviewAcademic(classId, termId) {
      let eco_user_id = this.user_info.eco_user_id ? this.user_info.eco_user_id : '';
      let url = process.env.VUE_APP_ECO_URL + '/api_eco.php/get_ar?class_id=' + classId + '&eco_id=' + eco_user_id + '&class_term=' + termId;
      this.redirect_blank(url);
    },

    reviewReport(class_id, date) {
      const month = date.month() + 1;
      const year = date.year();
      let url = process.env.VUE_APP_ECO_URL + '/api_monthly_report.php?student_id=' + this.user_info.eco_user_id + '&class_id=' + class_id + '&month=' + month + '&year=' + year;
      this.redirect_blank(url);
    },

    redirect_blank(url) {
      var a = document.createElement('a');
      a.target = "_blank";
      a.href = url;
      a.click();
    }
  }
}
</script>

<style scoped>
.nav-link {
  color: #00000080;
}

.nav-pills .nav-link {
  border-radius: 8px;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  background-color: #5AC9F7;
}

.item-academic {
  text-align: center;
}

.btn-preview {
  background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
  box-shadow: 0px 2px 0px 0px #FFFFFF33 inset;
  box-shadow: 4px 4px 0px 0px #00000012;
  height: 35px;
  width: 93px;
  left: 424px;
  top: 259px;
  border-radius: 30px;
  padding: 8px 20px 8px 20px;
  color: #fff;
  cursor: pointer;
  margin: 10px auto;
}

.item-academic-class {
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 10px;
}

.item-academic-name {
  font-family: Nunito;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
}
</style>